// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","link":"_3W5sZ _2aJ8N _1R_Wx","viewAllLink":"_7r64e _3W5sZ _2aJ8N _1R_Wx","viewAllBlock":"sCZMg","arrowIcon":"_1b4k6"};